import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Icon } from "../../designSystem";

const PaymentCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="lt-main">
      <div className="lt-result">
        <span className="lt-result__glyph lt-result__glyph--warning">
          <Icon name="block" style={{ verticalAlign: 0 }} />
        </span>
        <h1>购买已取消</h1>
        <p className="desc">
          您的购买已取消，未产生任何费用。如果改变主意，随时可以重新购买。
        </p>

        <div className="actions">
          <Button size="lg" onClick={() => navigate("/subscription/plans")}>
            重新购买
          </Button>
          <Button size="lg" variant="secondary" onClick={() => navigate("/")}>
            返回首页
          </Button>
        </div>

        <p className="foot">如有任何问题，请联系客服微信：lalambdada</p>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
